<script setup>
import { computed } from 'vue';
import Avatar from 'next/avatar/Avatar.vue';

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
const isLabel = computed(() => props.row.original.type === 'label');
const isAgent = computed(() => props.row.original.type === 'agent');
</script>

<template>
  <router-link
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="group/link flex min-w-0 items-center gap-3 rounded-md text-n-slate-12 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand"
  >
    <span
      v-if="isLabel"
      class="grid size-8 shrink-0 place-items-center rounded-lg bg-n-alpha-2"
      aria-hidden="true"
    >
      <span
        class="size-3 rounded-full border border-n-weak"
        :style="{
          backgroundColor: row.original.color || 'rgb(var(--slate-9))',
        }"
      />
    </span>
    <Avatar
      v-else
      :src="row.original.thumbnail || ''"
      :name="row.original.name || ''"
      :size="32"
      :rounded-full="isAgent"
      :status="isAgent ? row.original.status : null"
      :inbox="row.original.inbox"
      hide-offline-status
    />
    <span class="flex min-w-0 flex-col">
      <span
        class="truncate text-sm font-medium leading-5 group-hover/link:text-n-brand group-hover/link:underline"
        :title="row.original.name"
      >
        {{ row.original.name }}
      </span>
      <span
        v-if="row.original.subtitle"
        class="truncate text-xs text-n-slate-11"
        :title="row.original.subtitle"
      >
        {{ row.original.subtitle }}
      </span>
    </span>
  </router-link>
</template>
